import { Button } from 'react-bootstrap';

export const OnboardingToolbar = (props: {
  stepIndex: number;
  totalSteps: number;
  hideSkip?: boolean;
  nextDisabled?: boolean;
  nextButtonText?: string;
  onNext: () => void;
  onSkip: () => void;
}) => {
  const { stepIndex, totalSteps, hideSkip, nextDisabled, nextButtonText, onNext, onSkip } = props;
  return (
    <div className="onboarding__toolbar">
      <span className="growegy-title12--em">
        Step {stepIndex + 1} of {totalSteps - 1}
      </span>
      <div className="flex-grow-1" />
      {!hideSkip && (
        <Button
          type="submit"
          className="button-cancel"
          data-test="onboarding__skip-button"
          onClick={() => onSkip()}
        >
          Skip
        </Button>
      )}
      <Button
        type="submit"
        className="button-apply"
        data-test="onboarding__next-button"
        disabled={nextDisabled}
        onClick={() => onNext()}
      >
        {nextButtonText || 'Next'}
      </Button>
    </div>
  );
};
